const directives = {
  'scroll-load-more': {
    // 如果Select组件在Modal中，可以把bind函数变为update即可
    update(element, binding, vnode) {
      let _this = vnode.context; //获取vue上下文
      const SELECTWRAP_DOM = element.querySelector('.ivu-select .ivu-select-dropdown');
      //绑定scroll事件监听
      SELECTWRAP_DOM.addEventListener('scroll', function () {
        const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  }
};
